import React, { Component } from "react";
import MyContext from '../MyContext.jsx';
import { Link } from "react-router-dom";
import { CgSearch } from 'react-icons/cg';
import Select from "react-select";
import { generateAndShareBrowserPdf } from '../../assets/js/browserPdf.js';

import './PriceList.scss';

class PriceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      showing_products: [],
      category_options: [],
      selected_category: null,
      search_text: "",
      all_schemes: [],
      showSchemesPopup: false,
      selectedSchemes: [],
      selectedSchemeProductName: '',
      showProductImagePopup: false,
      selectedProductImage: null,
    }
    this.formChange = this.formChange.bind(this);
    this.categoryChange = this.categoryChange.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.generateCategoryPdf = this.generateCategoryPdf.bind(this);
    this.generateAllProductsPdf = this.generateAllProductsPdf.bind(this);
    this.generateSchemePdf = this.generateSchemePdf.bind(this);
    this.sanitizeFileName = this.sanitizeFileName.bind(this);
    this.getSchemesByProductId = this.getSchemesByProductId.bind(this);
    this.escapeHtml = this.escapeHtml.bind(this);
    this.b64toBlob = this.b64toBlob.bind(this);
    this.savePDF = this.savePDF.bind(this);
    this.sharePDF = this.sharePDF.bind(this);
  }

  applyFilters(searchText, selectedCategory) {
    const query = (searchText || "").toLowerCase().trim();
    const words = query ? query.split(/\s+/) : [];
    const selectedCategoryId = selectedCategory ? String(selectedCategory.value) : "";

    const showing_products = this.state.products.filter((item) => {
      const name = (item.name || "").toLowerCase();
      const itemCategoryId = String(item.category_id || "");
      const matchesCategory = !selectedCategoryId || itemCategoryId === String(selectedCategoryId);
      const matchesSearch = !words.length || words.every((word) => name.includes(word));
      return matchesCategory && matchesSearch;
    });

    this.setState({ showing_products });
  }

  componentDidMount() {
    document.body.classList.add('on-pricelist-page');
    var obj_this = this;
    const url2 = `${process.env.REACT_APP_SSS}/api/getProductList`;
    this.context.loading(1);
    $.ajax({
      url: url2,
      data: {
        sid: this.context.user_details.sid,
      },
      type: "POST"
    }).done(function (return_data) {

      if (return_data.status == "success") {
        var active_products = return_data.active_products;

        const categoryMap = new Map();
        active_products.forEach((item) => {
          if (!item || !item.category_id) return;
          const id = String(item.category_id);
          const name =
            (item.product_category && item.product_category.category_name) ||
            item.category_name ||
            "Unknown";
          if (!categoryMap.has(id)) {
            categoryMap.set(id, { value: id, label: name });
          }
        });

        const category_options = Array.from(categoryMap.values()).sort((a, b) =>
          String(a.label || "").localeCompare(String(b.label || ""))
        );

        obj_this.setState({
          products: active_products,
          showing_products: active_products,
          category_options,
          all_schemes: return_data.allschemes
        });
        obj_this.context.loading(0);
      } else {
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function () {
      obj_this.context.loading(0);
      alert("Network error");
    });
  }
  toggleSchemesPopup(schemes, productName = '') {
    this.setState({
      showSchemesPopup: !this.state.showSchemesPopup,
      selectedSchemes: schemes || [],
      selectedSchemeProductName: productName || ''
    });
  }
  toggleProductImagePopup = (image = null) => {
    this.setState({
      showProductImagePopup: !this.state.showProductImagePopup,
      selectedProductImage: image,
    });
  };

  escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  sanitizeFileName(name, fallback = 'document.pdf') {
    const raw = String(name == null ? '' : name).trim();
    const base = raw || fallback;
    const cleaned = base
      .replace(/[<>:"/\\|?*\x00-\x1F]/g, '-')
      .replace(/\s+/g, ' ')
      .replace(/\.+/g, '.')
      .replace(/^[\.\s-]+|[\.\s-]+$/g, '');

    if (!cleaned) {
      return fallback;
    }

    return cleaned.toLowerCase().endsWith('.pdf') ? cleaned : (cleaned + '.pdf');
  }

  getSchemesByProductId(productId) {
    return (this.state.all_schemes || []).filter(
      (scheme) => String(scheme.product_id) === String(productId)
    );
  }

  b64toBlob(b64Data, contentType) {
    const type = contentType || '';
    const sliceSize = 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type });
  }

  sharePDF(fileUrl, mimeType) {
    window.plugins.socialsharing.share(null, null, fileUrl, null, function (err) {
      console.error('Error sharing PDF:', err);
    }, {
      subject: 'Share PDF',
      mimeType: mimeType
    });
  }

  savePDF(base64Data, fileName) {
    const blob = this.b64toBlob(base64Data, 'application/pdf');
    const safeFileName = this.sanitizeFileName(fileName, 'document.pdf');
    const self = this;

    document.addEventListener('deviceready', function () {
      window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (dirEntry) {
        dirEntry.getFile(safeFileName, { create: true }, function (fileEntry) {
          fileEntry.createWriter(function (fileWriter) {
            fileWriter.onwriteend = function () {
              self.sharePDF(fileEntry.toURL(), 'application/pdf');
            };

            fileWriter.onerror = function (e) {
              console.log('Failed file write:', e.toString());
            };

            fileWriter.write(blob);
          }, function (err) {
            console.error('Error creating file writer:', err);
          });
        }, function (err) {
          console.error('Error getting file:', err);
        });
      }, function (err) {
        console.error('Error resolving file system URL:', err);
      });
    });
  }

  generateCategoryPdf() {
    const selectedCategory = this.state.selected_category;
    if (!selectedCategory) {
      // No category selected: generate all products PDF
      this.generateAllProductsPdf();
      return;
    }

    const productsToExport = this.state.showing_products || [];
    if (!productsToExport.length) {
      alert('No products found for selected filters.');
      return;
    }

    this.context.loading(1);
    const categoryLabel = selectedCategory.label || 'Category';
    const nowStr = new Date().toLocaleString('en-GB');

    let text = '<html><head><style>table, th, td {border: 1px solid; padding: 10px; text-align: center; font-size: 11px; margin:auto} td {white-space: nowrap;} table {width: 100%; border-collapse: collapse; margin: 0;} h4 {text-align: center;} .info {margin-bottom: 20px;} .info span {font-weight: bold;} </style></head><body>';

    text += '<h4><b>PRICE LIST</b></h4>';
    text += '<h4><u>Category: ' + this.escapeHtml(categoryLabel) + '</u></h4>';
    text += '<div class="info"><span>Generated :</span>&nbsp;&nbsp;' + this.escapeHtml(nowStr) + '</div>';

    const currencyLabel = this.context.currency ? ' (' + this.context.currency + ')' : '';
    text += '<table><thead><tr>' +
      '<th>Sl No.</th>' +
      '<th style="text-align: left;">Product</th>' +
      '<th>Unit</th>' +
      '<th>Rate' + currencyLabel + '</th>' +
      '</tr></thead><tbody>';

    for (let i = 0; i < productsToExport.length; i++) {
      const product = productsToExport[i];

      const unit = product.price ? (product.price.unit || '-') : '-';
      const rate = product.price ? ((product.price.total || '-')) : '-';

      text += '<tr>' +
        '<td>' + (i + 1) + '</td>' +
        '<td style="text-align: left;">' + this.escapeHtml(product.name || '-') + '</td>' +
        '<td>' + this.escapeHtml(unit) + '</td>' +
        '<td>' + this.escapeHtml(rate) + '</td>' +
        '</tr>';
    }

    text += '</tbody></table></body></html>';

    const options = {
      documentSize: 'A4',
      type: 'share',
      fileName: this.sanitizeFileName((categoryLabel || 'Category') + '-PriceList.pdf', 'Category-PriceList.pdf')
    };

    if (typeof window !== 'undefined' && window.cordova && typeof pdf !== 'undefined') {
      pdf.fromData(text, options)
        .then(() => {
          this.context.loading(0);
        })
        .catch((err) => {
          console.log(err);
          this.context.loading(0);
        });
    } else {
      generateAndShareBrowserPdf(text, options.fileName, () => {
        this.context.loading(0);
      });
    }
  }

  generateAllProductsPdf() {
    const productsToExport = this.state.products || [];
    if (!productsToExport.length) {
      alert('No products found.');
      return;
    }

    this.context.loading(1);
    const nowStr = new Date().toLocaleString('en-GB');

    let text = '<html><head><style>table, th, td {border: 1px solid; padding: 10px; text-align: center; font-size: 11px; margin:auto} td {white-space: nowrap;} table {width: 100%; border-collapse: collapse; margin: 0;} h4 {text-align: center;} .info {margin-bottom: 20px;} .info span {font-weight: bold;} </style></head><body>';

    text += '<h4><b>PRICE LIST</b></h4>';
    text += '<h4><u>Category: All Products</u></h4>';
    text += '<div class="info"><span>Generated :</span>&nbsp;&nbsp;' + this.escapeHtml(nowStr) + '</div>';

    const currencyLabel = this.context.currency ? ' (' + this.context.currency + ')' : '';
    text += '<table><thead><tr>' +
      '<th>Sl No.</th>' +
      '<th style="text-align: left;">Product</th>' +
      '<th>Unit</th>' +
      '<th>Rate' + currencyLabel + '</th>' +
      '</tr></thead><tbody>';

    for (let i = 0; i < productsToExport.length; i++) {
      const product = productsToExport[i];

      const unit = product.price ? (product.price.unit || '-') : '-';
      const rate = product.price ? (product.price.total || '-') : '-';

      text += '<tr>' +
        '<td>' + (i + 1) + '</td>' +
        '<td style="text-align: left;">' + this.escapeHtml(product.name || '-') + '</td>' +
        '<td>' + this.escapeHtml(unit) + '</td>' +
        '<td>' + this.escapeHtml(rate) + '</td>' +
        '</tr>';
    }

    text += '</tbody></table></body></html>';

    const options = {
      documentSize: 'A4',
      type: 'share',
      fileName: this.sanitizeFileName('All-Products-PriceList.pdf', 'All-Products-PriceList.pdf')
    };

    if (typeof window !== 'undefined' && window.cordova && typeof pdf !== 'undefined') {
      pdf.fromData(text, options)
        .then(() => {
          this.context.loading(0);
        })
        .catch((err) => {
          console.log(err);
          this.context.loading(0);
        });
    } else {
      generateAndShareBrowserPdf(text, options.fileName, () => {
        this.context.loading(0);
      });
    }
  }

  generateSchemePdf() {
    const schemes = this.state.selectedSchemes || [];
    const productName = this.state.selectedSchemeProductName || 'Product';

    if (!schemes.length) {
      alert('No schemes found for this product.');
      return;
    }

    this.context.loading(1);
    const nowStr = new Date().toLocaleString('en-GB');

    let text = '<html><head><style>table, th, td {border: 1px solid; padding: 10px; text-align: center; font-size: 11px; margin:auto} td {white-space: nowrap;} table {width: 100%; border-collapse: collapse; margin: 0;} h4 {text-align: center;} .info {margin-bottom: 20px;} .info span {font-weight: bold;} </style></head><body>';

    text += '<h4><b>PRODUCT SCHEME LIST</b></h4>';
    text += '<h4><u>' + this.escapeHtml(productName) + '</u></h4>';
    text += '<div class="info"><span>Generated :</span>&nbsp;&nbsp;' + this.escapeHtml(nowStr) + '</div>';

    text += '<table><thead><tr>' +
      '<th>Sl No.</th>' +
      '<th style="text-align: left;">Scheme Name</th>' +
      '<th>Range</th>' +
      '<th>Discount</th>' +
      '<th>Customers</th>' +
      '<th style="text-align: left;">Offer Product</th>' +
      '<th style="text-align: left;">Product Combo</th>' +
      '</tr></thead><tbody>';

    for (let i = 0; i < schemes.length; i++) {
      const scheme = schemes[i];
      const rangeText = scheme.range_type === 'Q'
        ? (scheme.range + ' (' + (scheme.range_unit || '-') + ')')
        : (scheme.range + ' (' + (scheme.range_unit || '-') + ')');
      const discountText = scheme.discount + ' ' + (scheme.discount_type == 'P' ? '%' : (scheme.discount_unit || ''));
      const customersText = scheme.customer_all == 'Y' ? 'All Customers' : (scheme.customers || '-');
      const offersText = scheme?.offer_products?.length
        ? scheme.offer_products.map((offer, offerIdx) => {
            return (offerIdx + 1) + '. ' + this.escapeHtml(offer.name || '-') + ' - ' + this.escapeHtml(offer.off_qty || '-') + ' ' + this.escapeHtml(offer.unit || '-');
          }).join('<br/>')
        : '-';
      const combosText = scheme?.combo_products?.length
        ? scheme.combo_products.map((combo, comboIdx) => {
            return (comboIdx + 1) + '. ' + this.escapeHtml(combo.name || '-');
          }).join('<br/>')
        : '-';

      text += '<tr>' +
        '<td>' + (i + 1) + '</td>' +
        '<td style="text-align: left;">' + this.escapeHtml(scheme.scheme_name || '-') + '</td>' +
        '<td>' + this.escapeHtml(rangeText) + '</td>' +
        '<td>' + this.escapeHtml(discountText) + '</td>' +
        '<td>' + this.escapeHtml(customersText) + '</td>' +
        '<td style="text-align: left;">' + offersText + '</td>' +
        '<td style="text-align: left;">' + combosText + '</td>' +
        '</tr>';
    }

    text += '</tbody></table></body></html>';

    const options = {
      documentSize: 'A4',
      type: 'share',
      fileName: this.sanitizeFileName((productName || 'Product') + '-Schemes.pdf', 'Product-Schemes.pdf')
    };

    if (typeof window !== 'undefined' && window.cordova && typeof pdf !== 'undefined') {
      pdf.fromData(text, options)
        .then(() => {
          this.context.loading(0);
        })
        .catch((err) => {
          console.log(err);
          this.context.loading(0);
        });
    } else {
      generateAndShareBrowserPdf(text, options.fileName, () => {
        this.context.loading(0);
      });
    }
  }

  formChange(e) {
    const value = e.target.value;
    this.setState({ search_text: value }, () => {
      this.applyFilters(this.state.search_text, this.state.selected_category);
    });
  }

  categoryChange(selectedCategory) {
    this.setState({ selected_category: selectedCategory }, () => {
      this.applyFilters(this.state.search_text, this.state.selected_category);
    });
  }  componentWillUnmount() {
    document.body.classList.remove('on-pricelist-page');
  }


  render() {
    const url=  `${process.env.REACT_APP_SSS}`;

    return (
      <MyContext.Consumer>
        {context => (
          <div className="price_list_page_container">
            <div className="page_header">
              
              <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Price List</div>
            </div>
            <div className="filters_row">
              <div className="search_container">
                <CgSearch />
                <input className="product_search_input"
                  placeholder="Search product.."
                  onChange={this.formChange}
                />
              </div>
              <div className="category_filter_container">
                <Select
                  options={this.state.category_options}
                  value={this.state.selected_category}
                  onChange={this.categoryChange}
                  isClearable
                  placeholder="All Categories"
                  className="category_filter"
                  classNamePrefix="category_filter"
                />
              </div>
              <button
                className="category_pdf_button"
                onClick={this.generateCategoryPdf}
              >
                Share Product PDF
              </button>
            </div>
            <div className="table_container">
              <table className="products_price_table">
                <thead>
                  <tr>
                    <th style={{ maxWidth: "40px" }} align="center">#</th>
                    <th style={{ minWidth: "80px" }}>Product</th>
                    <th style={{ maxWidth: "40px" }} align="center">Unit</th>
                    <th style={{ minWidth: "60px" }} align="center">Rate{this.context.currency ? ` (${this.context.currency})` : ''}</th>
                    <th style={{ minWidth: "80px" }} align="center">Schemes</th>
                    <th style={{ minWidth: "80px" }} align="center">Last Updated Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ display: this.state.showing_products.length ? "none" : "table-row" }}>
                    <td colSpan="6" align="center">No result!</td>
                  </tr>
                  {this.state.showing_products && this.state.showing_products.map((product, index) => (
                    <tr key={index} >

                      <td valign="top" align="center">{index + 1}</td>
                      <td valign="top" onClick={product.image ? () => this.toggleProductImagePopup(product.image) : null} style={{ fontWeight: product.image ? 'bold' : null }}>
                        {product.name}
                      </td>
                      {product.price ?
                        <td valign="top">{product.price.unit}</td> : <td valign="center">-</td>}
                      {product.price ?
                        <td valign="top"><span>{product.price.total}</span></td> : <td valign="center">-</td>}
                      <td valign="center">
                        {product.schemes.length ? (
                          <button
                            className="schemes-button"
                            onClick={() => this.toggleSchemesPopup(this.state.all_schemes.filter(scheme => scheme.product_id === product.product_id), product.name)}
                          >
                            View Schemes ({product.schemes.length})
                          </button>
                        ) : (
                          '-'
                        )}
                      </td>
                      {product.price ?
                        <td valign="center">{new Date(product.price.time).toLocaleString('en-GB')}</td> : <td valign="center">-</td>}

                    </tr>
                  ))}
                </tbody>
              </table>
              {this.state.showSchemesPopup && (
                <div className="schemes-popup-overlay">
                  <div className="schemes-popup">
                    <div className="schemes-popup-header">
                      <h3>Schemes: {this.state.selectedSchemeProductName || '-'}</h3>
                      <div className="schemes-popup-actions">
                        <button className="scheme_pdf_button" onClick={this.generateSchemePdf}>Share PDF</button>
                        <button onClick={() => this.toggleSchemesPopup()}>×</button>
                      </div>
                    </div>
                    <div className="schemes-popup-content">
                      <table className="schemes-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th style={{ minWidth: "120px" }}>Scheme Name</th>
                            <th style={{ minWidth: "60px" }}>Range</th>
                            <th style={{ minWidth: "60px" }}>Discount</th>
                            <th style={{ minWidth: "80px" }}>Customers</th>
                            <th style={{ minWidth: "150px" }} >Offer Product</th>
                            <th style={{ minWidth: "150px" }} >Product Combo</th>

                          </tr>
                        </thead>
                        <tbody>
                          {this.state.selectedSchemes.map((scheme, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{scheme.scheme_name}</td>
                              <td>
                                {scheme.range}{" "}
                                {scheme.range_type === "Q" ? (
                                  `(${scheme.range_unit})`
                                ) : (
                                  <span> ({scheme.range_unit})</span>
                                )}
                              </td>
                              <td>{scheme.discount} {scheme.discount_type == 'P' ? '%' : scheme.discount_unit}</td>
                              <td>{scheme.customer_all == 'Y' ? 'All Customers' : scheme.customers}</td>
                              <td minWidth={150}>
                                {scheme?.offer_products?.length ? (
                                  scheme.offer_products.map((product, index) => (
                                    <div key={index}>
                                      {scheme?.offer_products?.length > 0 ? (index + 1) + '.' : ''} {product.name} - {product.off_qty} {product.unit}
                                    </div>
                                  ))
                                ) : (
                                  '-'
                                )}
                              </td>
                              <td minWidth={150}>
                                {scheme?.combo_products?.length ? (
                                  scheme.combo_products.map((product, index) => (
                                    <div key={index}>
                                      {scheme?.combo_products?.length > 0 ? (index + 1) + '.' : ''} {product.name}
                                    </div>
                                  ))
                                ) : (
                                  '-'
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {this.state.showProductImagePopup && (
                <div className="product-image-popup-overlay">
                  <div className="product-image-popup">
                    <div className="product-image-popup-header">
                      <h3>Product Image</h3>
                      <button onClick={() => this.toggleProductImagePopup()}>×</button>
                    </div>
                    <div className="product-image-popup-content">
                      {this.state.selectedProductImage ? (
                        <img
                          src={url+'/'+this.state.selectedProductImage}
                          alt="No image available"
                          style={{ maxWidth: '100%', maxHeight: '100%' }}
                        />
                      ) : (
                        <p>No image available</p>
                      )}
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>

        )}
      </MyContext.Consumer>
    )
  }
}

export default PriceList;
PriceList.contextType = MyContext;
